import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { LoginService } from '../../auth/login.service';
import { applyPreferredLanguage } from '../utils/apply-preferred-language';
import { evaluateTwoFactorAccess } from './two-factor.guard';

export const AuthGuard: CanActivateFn = (_route, state) => {
  const loginService = inject(LoginService);
  const router = inject(Router);
  const translateService = inject(TranslateService);

  return loginService.ensureSession().pipe(
    map(ok => {
      if (!ok) {
        router.navigate(['/login']);
        return false;
      }

      applyPreferredLanguage(translateService, loginService.getUser()?.contact?.preferredLanguage);
      // Do not call TwoFactorGuard here — inject() is invalid inside map().
      return evaluateTwoFactorAccess(loginService, router, state);
    })
  );
};
